export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: "faq-1",
    question: "91.con 是什么平台？",
    answer: "91.con 是一个广受用户欢迎的综合网络平台，提供丰富的在线服务和内容。平台以其稳定的服务和优质的用户体验获得了大量忠实用户的青睐。",
  },
  {
    id: "faq-2",
    question: "如何找到 91.con 的最新官方地址？",
    answer: "您可以通过以下方式获取最新地址：(1) 收藏本导航页面，我们会实时更新；(2) 关注官方社交媒体账号；(3) 加入官方用户交流群获取通知。",
  },
  {
    id: "faq-3",
    question: "为什么 91.con 的地址会经常变化？",
    answer: "由于网络环境的复杂性，平台地址可能会因技术维护、网络优化或外部因素而调整。地址变更是为了给用户提供更稳定、更安全的访问体验。建议收藏本导航站，随时获取最新地址。",
  },
  {
    id: "faq-4",
    question: "91.con 是否安全？",
    answer: "91.con 官方平台使用 HTTPS 加密传输和多重安全防护措施保障用户数据和隐私安全。请务必通过官方渠道访问，谨防钓鱼网站。我们建议用户定期修改密码并开启安全验证功能。",
  },
  {
    id: "faq-5",
    question: "在手机和电脑上访问有什么区别？",
    answer: "91.con 同时提供桌面版和移动版，移动版针对小屏幕进行了全面优化，操作更便捷、加载更快。两个版本的账号和数据完全互通，您可以根据场景自由切换使用。",
  },
  {
    id: "faq-6",
    question: "访问时提示\"连接不安全\"怎么办？",
    answer: "如果浏览器提示连接不安全，请首先确认您访问的是否为官方正版地址。官方地址均使用 HTTPS 加密，如果确认地址正确但仍有提示，可能是本地时间设置错误或安全软件干扰，建议检查系统时间并暂时关闭安全软件后重试。",
  },
  {
    id: "faq-7",
    question: "忘记密码如何找回？",
    answer: "在登录页面点击\"忘记密码\"，按照提示通过绑定的手机号或邮箱进行验证后即可重置密码。如果绑定的联系方式已失效，请联系官方客服获取人工帮助。",
  },
  {
    id: "faq-8",
    question: "如何避免访问到虚假的 91.con 网站？",
    answer: "避免访问虚假网站的关键在于：(1) 通过本导航站获取地址，不点击来历不明的链接；(2) 检查地址栏是否有 HTTPS 安全锁；(3) 核对域名拼写是否完全正确；(4) 注意页面设计是否专业完整。",
  },
  {
    id: "faq-9",
    question: "91.con 支持哪些浏览器？",
    answer: "91.con 全面支持主流浏览器的最新版本，包括 Google Chrome、Mozilla Firefox、Microsoft Edge、Apple Safari 等。建议使用最新版浏览器以获得最佳的访问体验和安全性。",
  },
  {
    id: "faq-10",
    question: "为什么有时候网站加载很慢？",
    answer: "网站加载速度受多种因素影响：您的网络状况、同时在线用户数量、服务器负载等。如果遇到加载缓慢的情况，可以尝试：(1) 切换网络；(2) 使用备用地址；(3) 避开高峰时段访问。",
  },
];